import { get, post } from '@/api/axiosprovider';
import { IProxyPhoneDto } from '@/models';

const getProxyPhones = async (): Promise<IProxyPhoneDto[]> => {
	return await get('/api/proxyphones');
};

const postSyncProxyPhones = async (company: string): Promise<number> => {
	return await post<void, number>(`/api/proxyphones/sync/${company}`);
};

const postUnlockProxyPhone = async (proxyPhone: string): Promise<void> => {
	await post<void, void>(
		`/api/proxyphones/${encodeURIComponent(proxyPhone)}/unlock`
	);
};

export const proxyPhonesController = {
	getProxyPhones,
	postSyncProxyPhones,
	postUnlockProxyPhone
};
